import { render, staticRenderFns } from "./ria.vue?vue&type=template&id=f7bde170&scoped=true&"
import script from "./ria.vue?vue&type=script&lang=js&"
export * from "./ria.vue?vue&type=script&lang=js&"
import style0 from "./ria.vue?vue&type=style&index=0&id=f7bde170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bde170",
  null
  
)

export default component.exports